import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const PaidPassesV2 = (props) => {
  const token = window.localStorage.getItem('auth-token')

  const { operator: { id } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index distributors' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index paid-passes'>
      {/* eslint-disable-next-line */}
      <h1></h1>

      <cl-paid-passes
        apiUrl={`https://paid-passes.${env()}.credlock.net/api`}
        mountPath={`/operators/${id}/paid-passes-v2`}
        operatorid={id}
        token={token}
      />
    </div>
  )
}

export default PaidPassesV2
